export type Testimonial = { name: string; role: string; content: string };

export const testimonials: Testimonial[] = [
  {
    name: '王总',
    role: '某大型工业设备公司 技术经理',
    content:
      '"我们这个行业，最宝贵的就是老师傅的经验。以前这些经验都在人脑子里，人一走，技术就断层。词元映射团队帮我们要搭建的这套\'AI专家知识库\'，真正实现了把公司20年的技术积累数字化。现在年轻工程师遇到设备故障，拍张照问AI，30秒就能给出和总工一样的解决方案。这不仅是效率的提升，更是企业资产的保全。<strong>设备故障排查时间缩短了60%，新人培训周期从半年压缩到了1个月。</strong>"',
  },
  {
    name: '李总监',
    role: '某车企公司 运营负责人',
    content:
      '"以前做小红书和私域内容，文案团队每天憋不出几篇稿子，还要花大量时间找图，ROI总是打不正。用了这套针对我们品牌调性训练的AI工作流后，产能直接爆发。<strong>现在我们每天能通过AI产出50+篇高质量种草笔记，而且风格完全符合品牌SOP。</strong> 以前需要5个人干的活，现在1个门店1个人配合AI就能搞定，内容点击率还提升了2倍。真正的降本增效！"',
  },
  {
    name: '陈总',
    role: '某跨境出海企业 业务负责人',
    content:
      '面对全球不同时区的客户，语言和时差曾是我们最大的痛点。张总团队帮我们做的AI Agent不仅解决了多语言实时互译，还能按照我们设定的销售SOP进行精准逼单。现在我们的外贸员每天上班只需要处理AI筛选过的意向客户，<strong>成单效率提升了150%以上</strong>。',
  },
  {
    name: '周总',
    role: '某大型集团公司 运营负责人',
    content:
      '市面上卖标准SaaS软件的公司很多，但真正懂业务逻辑、能做深度定制的团队很少。<strong>张总团队最让我印象深刻的，是他们不仅懂技术，更懂\'业务流\'。</strong> 他们不是为了卖AI而卖AI，而是先梳理我们的痛点，再用Agent去解决具体环节的卡点。经过这次合作，我们内部现在已经习惯了\'有事问Agent\'，这种工作方式的变革才是最有价值的。',
  },
  {
    name: '陈总',
    role: '某头部短剧制作机构 内容合伙人',
    content:
      '短剧赛道拼的就是速度。以前一个剧本从大纲到分集再到分镜，磨合期至少两周。我们找词元映射团队开发并<strong>接入这个AI短剧生产力平台后，我们实现了\'工业化\'写作。</strong> 只要输入核心梗和反转点，AI能迅速生成符合短剧节奏的剧本结构，甚至直接对标当下的爆款逻辑。不管是做培训还是实际生产，效率提升是指数级的。第一期上线后，我们编剧团队的产出量直接翻了三倍。',
  },
  {
    name: '张总',
    role: '某高端家居装饰公司 CEO',
    content:
      '以前要给客户出效果图，设计师得画两三天，还没成交成本就出去了。<strong>现在利用词元映射团队定制的这套AI可视化玩法，客户在前端就能自己DIY出满意的风格，</strong> 我们的销售拿着客户自己生成的图去谈单，成功率极高。这种\'先体验、后销售\'的模式彻底改变了我们的谈单逻辑。系统上线后，不仅留资量上来了，连成交周期都缩短了一半。',
  },
  {
    name: '唐总',
    role: '某大型供应链/物流集团 运营副总',
    content:
      '我们的业务场景非常冷门且复杂，逻辑甚至有点反人性，很多团队听两遍就因为不耐烦而放弃了，或者做出来的东西根本没法用。<strong>只有梦飞总的团队，前前后后陪我们开了十几次需求会，比我们的产品经理还懂我们的业务逻辑。</strong> 遇到卡点时，你们没有把锅甩给\'技术实现不了\'，而是陪着我们一点点改方案、找路径。这种把客户的事当成自己事来做的责任感，让我觉得每一分钱都花得很值。',
  },
  {
    name: '罗总',
    role: '某大型零售/商贸企业 创始人',
    content:
      '"作为一个看重ROI的管理者，我不仅看重当下的投入，更看重未来的隐形成本。当时对比了一圈，市面上便宜的方案很多，但只有你们团队<strong>在前期就敢于花时间陪我们磨需求，而不是急着签单。</strong> 这半年下来，看着业务效率实打实地提升，我非常庆幸当时没有因为价格而妥协。<strong>交付非常扎实，没有隐形收费，服务还特别稳定。</strong> 这次合作证明了我的决策是正确的，你们确实是值得长期陪跑的合作伙伴。"',
  },
];
